const LOW_SIGNAL_EXACT_MESSAGES = new Set([
  'ok',
  'okay',
  'k',
  'kk',
  'no',
  'nope',
  'nah',
  'yes',
  'yep',
  'yeah',
  'hi',
  'hello',
  'hey',
  'thanks',
  'thank you',
  'thx',
  'cool',
  'got it',
  'just checking',
  'never mind',
  'nevermind',
  'its ok',
  "it's ok",
  'its okay',
  "it's okay",
  'i dont know',
  "i don't know",
  'no i was just asking',
  'no just wondering if you remembered them',
  'what',
  'what?',
]);

const LOW_SIGNAL_INTENTS = new Set([
  'null',
  'goodbye',
  'greeting',
  'trivia_answer',
]);

const STRONG_SIGNAL_INTENTS = new Set([
  'relationship_declaration',
  'loss',
  'emotion',
  'emotional_support',
  'identity_statement',
  'problem_statement',
  'goal_statement',
]);

export function normalizeSignalText(value = '') {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/[^\w\s']/g, '')
    .replace(/\s+/g, ' ');
}

export function hasMeaningfulEntities(context = {}) {
  return Array.isArray(context?.entities) && context.entities.length > 0;
}

export function isLowSignalMessage({
  message = '',
  intent = '',
  context = {},
  matchedTrigger = false,
  detectedAnswerToPendingQuestion = false,
} = {}) {
  if (matchedTrigger) return true;
  if (detectedAnswerToPendingQuestion) return true;
  if (hasMeaningfulEntities(context)) return false;

  const normalizedMessage = normalizeSignalText(message);
  const wordCount = normalizedMessage ? normalizedMessage.split(/\s+/).length : 0;

  const lowSignalStartsWith = [
    'no just',
    'just thinking',
    'just wondering',
    'just asking',
    'not really',
    'its ok',
    "it's ok",
    'its okay',
    "it's okay",
    'never mind',
    'nevermind',
  ];

  const lowSignalContains = [
    'just checking',
    'just asking',
    'just wondering',
    'not really specific',
    'nothing specific',
  ];

  if (!normalizedMessage) return true;
  if (LOW_SIGNAL_EXACT_MESSAGES.has(normalizedMessage)) return true;
  if (lowSignalStartsWith.some((phrase) => normalizedMessage.startsWith(phrase))) return true;
  if (lowSignalContains.some((phrase) => normalizedMessage.includes(phrase))) return true;
  if (LOW_SIGNAL_INTENTS.has(intent) && wordCount <= 8) return true;
  if (wordCount <= 4) return true;

  return false;
}

export function shouldUseVectorMemory({
  message = '',
  intent = '',
  context = {},
  matchedTrigger = false,
  detectedAnswerToPendingQuestion = false,
} = {}) {
  if (
    isLowSignalMessage({
      message,
      intent,
      context,
      matchedTrigger,
      detectedAnswerToPendingQuestion,
    })
  ) {
    return false;
  }

  if (hasMeaningfulEntities(context)) return true;

  const normalizedMessage = normalizeSignalText(message);
  const wordCount = normalizedMessage ? normalizedMessage.split(/\s+/).length : 0;

  if (STRONG_SIGNAL_INTENTS.has(intent)) return true;
  if (wordCount >= 6) return true;
  if (normalizedMessage.length >= 32) return true;

  return false;
}
